import React, { useCallback, useEffect, useState } from "react";
import Mainbackground from "../components/Mainbackground";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import "../Css/courses.css";
function Courses() {
  const path = "Courses";
  const { lang } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const [courses, setCourses] = useState([]);
  const [categories, setcategories] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const getCourses = useCallback(async () => {
    try {
      const [PortfolioRes, categoriesRes] = await Promise.all([
        axios.get(`${API_URL}/courses/Allcourses/${lang}`),
        axios.get(`${API_URL}/categories/Allcategories/${lang}`),
      ]);

      setCourses(PortfolioRes.data);
      setcategories(categoriesRes.data);
    } catch (error) {
      console.error("Error:", error);
    }
  }, [lang]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCourses();
  }, [getCourses]);
  const handleFilterClick = async (filter) => {
    setActiveFilter(filter);

    if (filter === "All") {
      setSearchResults(courses);
      return;
    }
    try {
      const res = await axios.get(
        `${API_URL}/courses/getCoursesByCategoryId/${filter}`
      );
      if (res.data.length === 0) {
        setSearchResults([]);
      }
      setSearchResults(res.data);
    } catch (error) {
      console.error("Error fetching filtered courses:", error);
      setSearchResults([]);
    }
  };

  const handleInputChange = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);

    let filteredResults = courses;
    // First filter by category
    if (activeFilter && activeFilter !== "All") {
      filteredResults = filteredResults.filter(
        (course) => course.category_id === activeFilter
      );
    }
    // Then filter by search query
    filteredResults = filteredResults.filter((course) =>
      course.title.toLowerCase().includes(query)
    );
    setSearchResults(filteredResults);
  };

  useEffect(() => {
    setSearchResults(courses);
  }, [courses]);
  useEffect(() => {
    if (activeFilter === "All") {
      setSearchResults(courses);
    } else if (activeFilter) {
      handleFilterClick(activeFilter);
    }
  }, [activeFilter]);

  return (
    <>
      <Mainbackground path={path} />
      <section className="margin_section">
        <div className="container">
          <div className="d-flex flex-wrap justify-content-between mb-3">
            <div>
              <form>
                <div className="input-group ">
                  <span className="input-group-text" id="basic-addon1">
                    <img
                      src={require("../assets/search.png")}
                      alt="search"
                      title="search"
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control search_input"
                    placeholder={lang === "ar" ? "بحث عن" : " Search ..."}
                    aria-label="search"
                    aria-describedby="basic-addon1"
                    value={searchQuery}
                    onChange={handleInputChange}
                  />
                </div>
              </form>
            </div>
            <div className="d-flex flex-wrap justify-content-center align-items-center">
              <button
                type="button"
                className={`btn btn-light ${
                  activeFilter === "All"
                    ? "hover_filter_btn_portfolio"
                    : "filter_portfolio"
                }`}
                onClick={() => handleFilterClick("All")}
              >
                {lang === "ar" ? "الكل" : "All"}
              </button>
              {categories.map((catg) => (
                <div key={catg.id}>
                  <button
                    type="button"
                    className={`btn btn-light ${
                      activeFilter === catg.id
                        ? "hover_filter_btn_portfolio"
                        : "filter_portfolio"
                    }`}
                    onClick={() => handleFilterClick(catg.id)}
                  >
                    {catg.categoryName}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="row d-flex justify-content-center align-items-center">
            {searchResults.length > 0 ? (
              searchResults.map((coursesData) => (
                <div
                  className="col-lg-4 col-md-12 col-sm-12 mb-4"
                  key={coursesData.id}
                >
                  <Link
                    to={`/${lang}/coursedetails/${coursesData.id}`}
                    key={coursesData.id}
                  >
                    <div className="card text-bg-dark card_portfolio">
                      <img
                        src={`${API_URL}/${coursesData.image}`}
                        className="card-img img_portfolio"
                        alt="website img"
                        title="website-img"
                        loading="lazy"
                      />
                      <div className="card-img-overlay card_cont_portfolio">
                        <h5 className="card-title card_title_portfolio">
                          {coursesData.title}
                        </h5>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="col-lg-12 col-md-12 col-sm-12">
                <p className="text-center text_portfolio_empty">
                  {lang === "ar" ? "لا يوجد دورات" : "No Courses found."}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Courses;
